import React from 'react'
import { DefaultLayout } from '../../layouts'
import { SimplePageHeader } from '../../components'
import { MainContent } from './components'

const Faq = () => {
  return (
    <DefaultLayout>
      <SimplePageHeader title="FAQ" largePadding />
      <MainContent />
    </DefaultLayout>
  )
}

export { Faq }
